import React from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Grid, Header } from 'semantic-ui-react'

import { IProject } from '../../../api/Data'

import CollaborateTabEmbed from './CollaborateTabEmbed'
import CollaborateTabQRCode from './CollaborateTabQRCode'
import CollaborateTabShareLinks from './CollaborateTabShareLinks'
import CollaborateTabApi from './CollaborateTabApi'
import CollaborateTabHelp from './CollaborateTabHelp'

const CollaborateTabSharingPage = (props: IProps) => {
  // Props
  const { project } = props
  
  return (
    <>
      <Grid columns={1} stackable>
        <Grid.Column>
          <Header as="h1" style={{ marginBottom: '2rem', fontWeight: 'bold' }}>
            Shareable Upload Link
            <Header.Subheader>
              Collect new video submissions from anyone with the link
            </Header.Subheader>
            <Header.Subheader>
              Bring in fresh video content with ease. Share links, QR codes, API hooks, or embed widgets to invite people to <strong>submit videos</strong>. More contributors = more stories for your project.
            </Header.Subheader>
          </Header>

          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', width: '50%', backgroundColor: '#ffffff', border: '1px solid rgb(243, 244, 245)', borderTopLeftRadius: '20px', padding: '20px' }}>
              <CollaborateTabShareLinks project={project} />
              <div style={{ position: 'absolute', bottom: '-10px', right: '-20px' }}>
                <strong style={{ backgroundColor: '#ffffff', padding: '10px' }}>OR</strong>
              </div>
            </div>
            <div style={{ width: '50%', backgroundColor: '#ffffff', border: '1px solid rgb(243, 244, 245)', borderTopRightRadius: '20px', padding: '20px' }}>
              <CollaborateTabQRCode project={project} />
            </div>
            <div style={{ width: '50%', backgroundColor: '#ffffff', border: '1px solid rgb(243, 244, 245)', borderBottomLeftRadius: '20px', padding: '20px' }}>
              <CollaborateTabEmbed project={project} />
            </div>
            <div style={{ width: '50%', backgroundColor: '#ffffff', border: '1px solid rgb(243, 244, 245)', borderBottomRightRadius: '20px', padding: '20px' }}>
            <CollaborateTabApi />
            </div>
          </div>
        </Grid.Column>
        
        <Grid.Column>
          <div style={{ display: 'flex', flexWrap: 'wrap', backgroundColor: '#ffffff', border: '20px', borderRadius: '20px', padding: '20px' }}>
            <CollaborateTabHelp />
          </div>
        </Grid.Column>
      </Grid>
    </>
  )
}

interface IProps extends RouteComponentProps<any> {
  project: IProject
}

export default withRouter(CollaborateTabSharingPage)
